export default [
  {
    path: '/admin/products',
    name: 'Products',
    component: () => import('@/views/Admin/Projects/Index.vue'),
    meta: {
      pageTitle: 'Ürün Yönetimi',
      breadcrumb: [
        {
          text: 'Listele',
          active: true,
        },
      ],
      resource: 'ADMIN_PRODUCTS',
      action: 'read',
    },
  },
  {
    path: '/admin/projects/add',
    name: 'ProductAdd',
    component: () => import('@/views/Admin/Projects/Add.vue'),
    meta: {
      pageTitle: 'Ürün Yönetimi',
      breadcrumb: [
        {
          text: 'Listele',
          to: '/admin/products',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_PRODUCTS_ADD',
      action: 'read',
    },
  },
  {
    path: '/admin/projects/edit/:id',
    name: 'ProductEdit',
    component: () => import('@/views/Admin/Projects/Edit.vue'),
    meta: {
      pageTitle: 'Ürün Yönetimi',
      breadcrumb: [
        {
          text: 'Listele',
          to: '/admin/products',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_PRODUCTS_EDIT',
      action: 'read',
    },
  },
]
